const d="GraphQL Client";function l(n){return n instanceof Error?n.message:JSON.stringify(n)}function p({client:n,retries:t}){if(t!==void 0&&(typeof t!="number"||t<0||t>3))throw new Error(`${n}: The provided "retries" value (${t}) is invalid - it cannot be less than 0 or greater than 3`)}const g=`${d}: An error occurred while fetching from the API. Review 'graphQLErrors' for details.`,C=`${d}: Response returned unexpected Content-Type:`,m={json:"application/json",multipart:"multipart/mixed"},I=1e3,$=[429,503];function f({headers:n,url:t,fetchApi:e=fetch,retries:r=0,logger:a}){p({client:d,retries:r});const o={headers:n,url:t,retries:r},c=E(a),s=T(e,c),i=b(s,o),u=D(i);return{config:o,fetch:i,request:u}}async function S(n){return new Promise(t=>setTimeout(t,n))}async function A(n){const{errors:t,data:e,extensions:r}=await n.json();return{...e?{data:e}:{},...r?{extensions:r}:{},...t||!e?{errors:{networkStatusCode:n.status,message:t?g:`${d}: An unknown error has occurred. The API did not return a data object or any errors in its response.`,...t?{graphQLErrors:t}:{}}}:{}}}function E(n){return t=>{n&&n(t)}}function T(n,t){const e=async(r,a,o)=>{const c=a+1,s=o+1;let i;try{if(i=await n(...r),t({type:"HTTP-Response",content:{requestParams:r,response:i}}),!i.ok&&$.includes(i.status)&&c<=s)throw new Error;return i}catch(u){if(c<=s)return await S(I),t({type:"HTTP-Retry",content:{requestParams:r,lastResponse:i,retryAttempt:a,maxRetries:o}}),e(r,c,o);throw new Error(`${d}:${o>0?` Attempted maximum number of ${o} network retries. Last message -`:""} ${l(u)}`)}};return e}function b(n,{url:t,headers:e,retries:r}){return async(a,o={})=>{const{variables:c,headers:s,url:i,retries:u}=o,y=JSON.stringify({query:a,variables:c});p({client:d,retries:u});const h=[i??t,{method:"POST",headers:{...e,...s},body:y}];return n(h,1,u??r)}}function D(n){return async(...t)=>{try{const e=await n(...t),{status:r,statusText:a}=e,o=e.headers.get("content-type")||"";return e.ok?o.includes(m.json)?A(e):{errors:{networkStatusCode:r,message:`${C} ${o}`}}:{errors:{networkStatusCode:r,message:a}}}catch(e){return{errors:{message:l(e)}}}}}class P{constructor(){var t,e;this.client=f({url:"https://gentlemensshopcom.myshopify.com/api/2023-10/graphql.json",headers:{"Content-Type":"application/json","X-Shopify-Storefront-Access-Token":"9d09a3cb11c0317852f4db2cfdcba1e7"},retries:3}),this.shopMarket=this.GetMarketHandle()||"",this.shopLanguage=((t=this.GetShopLanguage())==null?void 0:t.toLocaleUpperCase())||"",this.shopCountry=((e=this.GetShopCountry())==null?void 0:e.toLocaleUpperCase())||""}DecreaseLineItemsFromCart(t,e){console.log(`Decreasing quantity of ${e.length} lineitem(s) by one item from cart ${t}`);let r=`gid://shopify/Cart/${t}`;const a=`
      mutation cartLinesUpdate($cartId: ID!, $lines: [CartLineUpdateInput!]!) {
        cartLinesUpdate(cartId: $cartId, lines: $lines) {
          cart {
            id
          }
        }
      }
    `;return this.client.request(a,{variables:{cartId:r,lines:e}})}CreateCart(t){console.log("Creating cart.");const e=`
      mutation cartCreate($input: CartInput!) {
        cartCreate(input: $input) {
          cart {
            id
            discountCodes {
              code
            }
          }
        }
      }
    `;return this.client.request(e,{variables:{input:t}})}GetProductInfo(t){console.log(`Getting product information for ${t}`);let e=btoa(`gid://shopify/Product/${t}`);const r=`
      query GetProductInfo($productGID: ID!, $country: CountryCode!) 
        @inContext(country: $country) {
        node(id: $productGID) {
          ... on Product {
            variants(first: 10) {
              nodes {
                availableForSale
                id
                compareAtPrice {
                  currencyCode
                  amount
                }
                price {
                  currencyCode
                  amount
                }
                image {
                  originalSrc
                }
                title
                currentlyNotInStock
              }
            }
            onlineStoreUrl
            title
            availableForSale
          }
        }
      }
    `;return this.client.request(r,{variables:{productGID:e,country:this.shopCountry}})}GetProductVariantInfo(t){console.log(`Getting product information for variantId ${t}`);let e=btoa(`gid://shopify/ProductVariant/${t}`);const r=`
    query GetProductVariantInfo($variantGID: ID!, $country: CountryCode!) 
    @inContext(country: $country) {
      node(id: $variantGID) {
        ... on ProductVariant {
          availableForSale
          image {
            originalSrc
          }
          price {
            amount
            currencyCode
          } 
          title
          product {
            title
            onlineStoreUrl
          }
          compareAtPrice {
            amount
            currencyCode
          }
        }
      }
    }
  `;return this.client.request(r,{variables:{variantGID:e,country:this.shopCountry}})}AddLineItemsToCartCartjs(t){let e=[];for(const r of t)e.push({id:r,quantity:1});return fetch(window.Shopify.routes.root+"cart/add.js",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({items:e})})}AddLineItemsToCart(t,e){console.log(`Add lineitems ${e} to cart ${t}`);let r=`gid://shopify/Cart/${t}`;const a=`
    mutation addCartLines($cartId: ID!, $lines: [CartLineInput!]!, $country: CountryCode!) 
    @inContext(country: $country) {
        cartLinesAdd(cartId: $cartId, lines: $lines) {
          cart {
            id
            discountCodes {
              applicable
              code
            }
            discountAllocations {
              ... on CartCodeDiscountAllocation {
                __typename
                code
                discountedAmount {
                  amount
                  currencyCode
                }
              }
            }
            lines(first: 100){
              edges
              {
                node {
                  id
                  discountAllocations {
                    ... on CartAutomaticDiscountAllocation {
                      __typename
                    }
                    ... on CartCodeDiscountAllocation {
                      __typename
                    }
                    ... on CartCustomDiscountAllocation {
                      __typename
                    }
                    discountedAmount {
                      amount
                      currencyCode
                    }
                  }
                  quantity
                      merchandise{
                          ... on ProductVariant {   						
                              id
                          }
                      }
                      cost {
                        amountPerQuantity {
                          amount
                        }
                        compareAtAmountPerQuantity {
                          amount
                        }
                        totalAmount {
                          amount
                          currencyCode
                        }
                      }
                    }
                  }
                }
              }
            }
          }
    `;let o=[];for(const c of e)o.push({merchandiseId:`gid://shopify/ProductVariant/${c}`,quantity:1});return this.client.request(a,{variables:{cartId:r,lines:o,country:this.shopCountry}})}GetMarketHandle(){const t=document.getElementById("MarketHandle");return console.log("Market Handle: "+t.getAttribute("data-market")),t.getAttribute("data-market")}GetShopLanguage(){const t=document.getElementById("MarketHandle");return console.log("Shop Language: "+t.getAttribute("data-language")),t.getAttribute("data-language")}GetShopCountry(){const t=document.getElementById("MarketHandle");return console.log("Shop Country: "+t.getAttribute("data-country")),t.getAttribute("data-country")}SetCartDiscountCodes(t,e){console.log(`Applying to Cart with ID ${t} discount codes with name ${e}`);let r=`gid://shopify/Cart/${t}`;const a=`
        mutation cartDiscountCodesUpdate($cartId: ID!, $discountCodes: [String!]) {
          cartDiscountCodesUpdate(cartId: $cartId, discountCodes: $discountCodes) {
            userErrors {
              field
              message
            }
          }
        }
      `;return this.client.request(a,{variables:{cartId:r,discountCodes:e}})}GetDiscountCodesFromCart(t){console.log(`Getting discount codes from Cart with ID ${t}`);let e=`gid://shopify/Cart/${t}`;const r=`
        query GetDiscountCodesFromCart($cartId: ID!) {
          cart(id: $cartId) {
            discountCodes {
              code
            }
          }
        }

      `;return this.client.request(r,{variables:{cartId:e}})}PredictiveSearch(t,e=5){console.log(`Predictive search for "${t}"`);const r=`
      query PredictiveSearch($searchQuery: String!, $limit: Int!, $country: CountryCode!, $language: LanguageCode!)
        @inContext(country: $country, language: $language) {
        predictiveSearch(query: $searchQuery, limit: $limit, types: [PRODUCT]) {
          products {
            id
            title
            description(truncateAt: 90)
            onlineStoreUrl
            featuredImage {
              url
              altText
            }
            priceRange {
              minVariantPrice {
                amount
                currencyCode
              }
            }
            compareAtPriceRange {
              minVariantPrice {
                amount
                currencyCode
              }
            }
          }
        }
      }
    `;return this.client.request(r,{variables:{searchQuery:t,limit:e,country:this.shopCountry||"DE",language:this.shopLanguage||"DE"}})}GetProductsInCollection(t){console.log(`Getting products from collection with ID ${t}`);let e=`gid://shopify/Collection/${t}`;const r=`
        query getProductIDs($collectionId: ID!) {
          collection(id: $collectionId) {
            products(first: 100) {
              nodes {
                id
              }
            }
          }
        }
      `;return this.client.request(r,{variables:{collectionId:e}})}}export{P as S};
//# sourceMappingURL=shopifyclient-6d7b4b5d.js.map
